export default {
  PRODUCTS: "/products",
  DISCOUNTS: "/discounts",
  INCOME: "/income",
};
